import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16205 20099"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M8103 11013c-952 0-1845-370-2518-1043-672-672-1042-1566-1042-2516V4141c0-174 141-315 314-315 174 0 314 141 314 315v3313c0 782 305 1518 859 2072 553 553 1289 859 2072 859 1617 0 2932-1315 2932-2931V3470c0-173 140-314 313-314 174 0 315 141 315 314v3984c0 950-371 1844-1043 2516s-1566 1043-2516 1043z"
        className="fil0"
      />
      <path
        d="M6480 12959c-174 0-314-140-314-313v-2381c0-174 140-314 314-314 173 0 314 140 314 314v2381c0 173-141 314-314 313zM9725 12959c-173 0-314-140-314-313v-2381c0-174 141-314 314-314s314 140 314 314v2381c0 173-141 314-314 313zM6804 6794c-173 0-314-140-314-315v-648c0-174 141-314 314-314 174 0 314 141 314 314v648c0 175-140 315-314 315zM9400 6794c-173 0-313-140-313-315v-648c0-174 140-314 313-314 174 0 314 141 314 314v648c0 175-140 315-314 315zM7170 8092c131 389 500 670 932 670 433 0 802-281 933-670H7170zm933 1298c-890 0-1613-723-1613-1612 0-174 141-314 314-314h2596c174 0 314 141 314 314 0 889-723 1612-1612 1612h1z"
        className="fil0"
      />
      <path
        d="M628 19471h14949v-4648l-5787-1827-1491 1193c-115 91-278 92-393 0l-1492-1193-5786 1827v4648zm15263 628H314c-173 0-314-140-314-314v-5192c0-137 89-258 219-300l6166-1947c100-32 209-11 291 55l1427 1140 1426-1140c81-66 190-87 291-55l6165 1947c131 42 220 162 220 300v5192c0 173-141 314-314 314z"
        className="fil0"
      />
      <path
        d="M13944 20099c-174 0-314-140-314-314v-3570c0-173 140-314 314-314 173 0 314 141 314 315v3569c0 173-141 314-314 314z"
        className="fil0"
      />
      <path
        d="M15891 18801h-1947c-174 0-314-140-314-315 0-173 140-313 314-313h1947c173 0 314 140 314 313 0 175-141 315-314 315zM2261 20099c-173 0-314-140-314-314v-3570c0-173 141-314 314-314 174 0 314 141 314 315v3569c0 173-141 314-314 314z"
        className="fil0"
      />
      <path
        d="M2261 18801H314c-173 0-314-140-314-315 0-173 141-313 314-313h1947c174 0 314 140 314 313 0 175-141 315-314 315zM4522 2575v652c0 367 299 667 668 667h651v-652c0-368-299-667-667-667h-652zm1633 1947h-965c-715 0-1296-581-1296-1295v-966c0-173 141-314 314-314h966c714 0 1295 581 1295 1295v966c0 174-140 315-314 315v-1z"
        className="fil0"
      />
      <path
        d="M6469 3894h3238c1089 0 1976-886 1976-1976V628H9426c-1630 0-2957 1327-2957 2957v309zm3238 628H6155c-173 0-314-140-314-314v-623c0-957 373-1858 1050-2535C7569 373 8469 0 9426 0h2571c173 0 314 140 314 314v1604c0 1436-1169 2605-2604 2605v-1z"
        className="fil0"
      />
      <path
        d="M6155 4522c-173 0-314-140-314-314 0-777 303-1508 852-2058 550-549 1281-852 2058-852h1623c173 0 314 141 314 314 0 174-141 314-314 314H8751c-1258 0-2282 1024-2282 2282 0 174-140 315-314 314zM7629 14917l474 474 473-474-473-474-474 474zm474 1232c-81 0-161-31-223-92l-918-918c-59-59-92-138-92-222 0-83 33-163 92-222l918-918c123-122 322-122 445 0l917 918c123 123 123 322 0 444l-917 918c-62 61-143 92-223 92h1z"
        className="fil0"
      />
      <path
        d="m7188 18426 915 915 914-915-914-1789-915 1789zm915 1673c-81 0-161-31-223-92l-1298-1298c-96-97-120-244-57-365l1298-2541c53-104 161-170 279-170 118-1 226 66 280 170l1298 2541c62 121 39 268-58 365l-1297 1298c-62 61-143 92-223 92h1zM3873 17199h1319v-670H3873v670zm1633 628H3559c-173 0-314-140-314-314v-1298c0-173 141-314 314-314h1947c173 0 314 141 314 315v1297c0 173-141 314-314 314z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
